import React from "react";
import { Map, Marker, GoogleApiWrapper } from "google-maps-react";

export class MapContainer extends React.Component {
  render() {
    return (
      <Map google={this.props.google} zoom={this.props.zoom} initialCenter={this.props.initialCenter} disableDefaultUI={true}>
        <Marker name={"Current location"} />
      </Map>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyDnbu0I4buK02QJLDVfKx941tIJ5Tl1C5M",
})(MapContainer);
